import React from 'react';
import './index.scss';
const AbsoluteModal = (props: any) => {
  return <div className="modal_absolute" style={{
    left: props.left ?? '',
    right: props.right ?? '',
    top: props.top ?? '',
    bottom: props.bottom ?? ''
  }} onMouseEnter={props.onMouseEnter ?? null} onMouseLeave={props.onMouseLeave ?? null} data-sentry-component="AbsoluteModal" data-sentry-source-file="index.tsx">
      {props.children}
    </div>;
};
export default AbsoluteModal;